module.exports = __webpack_public_path__ + "static/img/champ.043f466a.jpg";